import { useQuery } from "@tanstack/react-query";

import type { ShipmentClaimReason } from "~/shared/schemas/shipment-management-schema.ts";
import { claimReasonSchema } from "~/shared/schemas/shipment-management-schema.ts";
import { apiRoutes } from "~/shared/services/api/api-routes.ts";
import { getAndValidate } from "~/shared/services/api/fetch-client.ts";

const getClaimReasons = async (): Promise<ShipmentClaimReason[]> => {
	const resp = await getAndValidate(
		apiRoutes.GETCLAIMS,
		claimReasonSchema.array(),
	);
	if (resp.success) {
		return resp.data;
	}
	console.error("Failed to fetch claim reasons:", resp.error);
	return [];
};
export const useGetClaimReasons = () => {
	const { data, error, isLoading } = useQuery({
		queryKey: ["claimReasons"],
		queryFn: () => getClaimReasons(),
		staleTime: 5 * 60 * 1000, // 5 minutes
	});
	return { claimReasons: data ?? [], error, isLoading };
};
